import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import dayjs from "dayjs";
import Alert from "@mui/material/Alert";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import EmojiEmotionsIcon from "@mui/icons-material/EmojiEmotions";
import TextInput from "../Forms/TextInput";
import DateInput from "../Forms/DateInput";
import ButtonForm from "../Button/ButtonForm";
import { useAuth } from "../../provider";
import Grid from '@mui/material/Grid';


const BloodMarkerAddForm = ({ url_add, targetNavigation, fieldName, fieldLabel, placeholder }) => {

  const { state } = useAuth();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState();
  const [error, setError] = useState();

  const handleSubmit = async (values) => {
    setLoading(true);
    try {
      const response = await axios.post(url_add, values);
      if (response.status === 200 || response.status === 201) {
        setMessage("Success!");
        navigate(targetNavigation, { replace: true });
      }
    } catch (err) {
      setError(err.message || "Unknown error");
      if (err.response) console.log(err.response.data, err.response.status);
      else if (err.request) console.log(err.request);
      else console.log("Error", err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
<Grid container>
  <Grid size={12} sx={{display:'flex', justifyContent:'center', alignItems:'center'}}>
            
    <Formik
    
        initialValues={{ date: "", [fieldName]: "", owner: state.user.id }}
        validationSchema={Yup.object().shape({
            date: Yup.date().nullable().required("Required"),
            [fieldName]: Yup.number().positive("Must be a positive number").required("Required!"),
            })}
        onSubmit={async (values, { setSubmitting }) => {
        await handleSubmit(values);
        setSubmitting(false);
      }}
    >
      {({ values, setFieldValue, isSubmitting }) => (
        <Form>
          <DateInput
            label="Select Date"
            name="date"
            type="date"
            value={values.date ? dayjs(values.date) : null}
            onChange={(date) => {
              const formattedDate = date
                ? dayjs(date).format("YYYY-MM-DD")
                : "";
              setFieldValue("date", formattedDate);
            }}
          />

          <TextInput
            label={fieldLabel}
            name={fieldName}
            type="text"
            placeholder={placeholder || "Insert value"}
          />

          <ButtonForm name="Submit" disabled={isSubmitting || loading} />

          {loading && <span>Please wait ... uploading data</span>}

          {message && (
            <Alert
              icon={<EmojiEmotionsIcon fontSize="inherit" />}
              variant="filled"
              severity="success"
              sx={{ mt: 4, borderRadius: "24px" }}
            >
              {message}
            </Alert>
          )}

          {error && (
            <Alert
              icon={<ReportProblemIcon fontSize="inherit" />}
              variant="filled"
              severity="error"
              sx={{ mt: 2, borderRadius: "24px" }}
            >
              Check your input! &nbsp; {error}
            </Alert>
          )}
        </Form>
      )}
    </Formik>
    </Grid>
  </Grid>
  );
};

export default BloodMarkerAddForm;
